/**
 *  users.js
 *  @version: 1.0.0
 *  @author: DWIT MÉXICO
 *  @description: Manejador de ejecuciones del Context para Usuarios
 */

 import Request from "../core/httpClient"; 

 const req = new Request(); 

export async function loadUser() {
  let user = window.localStorage.getItem("iGateAdminA");

  if (user) {
    user = JSON.parse(user);
    const res = await req.post('/tiendas/tokuser', { id: user.id }); 

        if (res.data) {

            user.id = JSON.parse(res.data);

        } else {

            user.id = { id: 0, tipo: 0 }
        } 

    this.setState({ user: user });
    return user;
  } else {
    window.localStorage.setItem("iGateAdminA", '{"auth": false}');
    window.localStorage.removeItem("iGateAdminA");
    this.setState({ user: { auth: false } });
  }
}

export function login(data) {
  window.localStorage.setItem("iGateAdminA", JSON.stringify(data));
  this.setState({ user: data });
}

export function logout() {
  window.localStorage.setItem("iGateAdminA", '{"auth": false}');
  window.localStorage.removeItem("iGateAdminA");
  this.setState({ user: { auth: false } });
}
